import type { CSSProperties } from "react";

export const ModalStyles: CSSProperties = {
    position: "fixed",
    inset: "0",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
}

export const ModalContentStyles: CSSProperties = {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25)",
    width: "100%",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    maxWidth: "600px"
}

export const ModalBodyStyles: CSSProperties = {
    overflowY: "auto",
    flex: "1 1 auto",
    padding: "10px 10px",
}

export const ModalHeaderStyles: CSSProperties = {
    padding: "10px 10px 0px",
    overflowY: "auto",
    flex: "1 1 auto",
}

export const ModalFooterStyles: CSSProperties = {
    padding: "10px",
}

export const ModalHeadingStyles: CSSProperties = {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#1e1e1e",
    margin: "0",
}

export const ModalFooterActionsStyles: CSSProperties = {
    display: "flex",
    justifyContent: "end",
    gap: "10px",
}